<template>

    <div class="brt-map-navingTipModule" ref="navingTipModule">


        <!--跨层方式选择-->
        <div class="route-floorType-module" v-if="(moduleState == 1 || (moduleState == 0 && brtmap.$route.route && brtmap.$route.route.length>1)) && !brtmap.$route.vehicle  && !brtmap.$route.isExit">
            <div v-for="(item,index) in routeSelect" :class="index == routeIndex?'wrap active':'wrap'" @click="changeRoute(index,item)" >
                <i :class="'iconfont icon-'+item.icon"></i>
                <span>{{item.name}}</span>
            </div>
        </div>

        <!--已选起终点显示-->
        <div class="box" :state="moduleState" v-if="moduleState == 0">

            <p class="tip">约{{allDistant}}米&nbsp;&nbsp;({{allTime}}分钟)&nbsp;&nbsp;<span v-if="!floorTxt">无需跨楼层</span><span v-else>{{floorTxt}}</span></p>

            <div class="btn-box">

                <Button type="border" icon="icon-nav" @click.native="goToNav('analog')">模拟导航</Button>

                <Button icon="icon-AR" @click.native="goToNav('ar')" v-if="$systemEnviron == 2 && !$BRT.$route.vehicle">实景导航</Button>

                <Button icon="icon-walk" @click.native="goToNav('walk')" v-if="!$BRT.$route.vehicle">步行导航</Button>

                <Button icon="icon-cheliangguanli" @click.native="goToNav('vehicle')" v-else>车行导航</Button>
            </div>

        </div>


        <!--无路线方式-->
        <div class="box no-route" v-if="moduleState == 1">

            <div class="wrap">

                <img src="../../../../../../public/images/zanwu.png" alt="无路线">

                <span>此方式无路线 <br> 请重新选择</span>

            </div>

        </div>

        <!--选择起点-->
        <div class="box setPoint" v-if="moduleState == 2">

            <div class="wrap">

                <img src="../../../../../../public/images/start_icon.png" alt="选点">

                <span>请在顶部 <br> 输入起点</span>

            </div>

        </div>

        <!--选择终点-->
        <div class="box setPoint" v-if="moduleState == 3">

            <div class="wrap">

                <img src="../../../../../../public/images/end_icon.png" alt="选点">

                <span>请在顶部 <br> 输入终点</span>

            </div>

        </div>


        <!--模拟导航提示-->
        <div class="box navingTip aa" v-if="moduleState == 4">

            <div class="l-box" @click="back('analog')">退出</div>

            <div class="c-box" @click="check = !check">
                <p v-if="!check">当前&nbsp;<span>{{floorNAME}}</span>&nbsp;终点&nbsp;<span>{{endINFO}}&nbsp;</span></p>
                <p v-else>剩&nbsp;<span>{{distant}}</span>&nbsp;米&nbsp;<span>{{minute}}</span>&nbsp;分钟</p>
            </div>

            <div class="r-box" @click="isPlay('analog')">
                <i class="iconfont icon-play" v-if="!pauseNaving"></i>
                <i class="iconfont icon-pause" v-else></i>
            </div>

        </div>


        <!--步行导航提示-->
        <div class="box navingTip" v-if="moduleState == 5">

            <div class="l-box" @click="back('walk')">退出</div>

            <div class="c-box" v-if="!overView"  @click="check? check=false : check=true">
                <p v-if="!check">当前&nbsp;<span>{{floorNAME}}</span>&nbsp;终点&nbsp;<span>{{endINFO}}&nbsp;</span></p>
                <p v-else>剩&nbsp;<span>{{distant}}</span>&nbsp;米&nbsp;<span>{{minute}}</span>&nbsp;分钟</p>
            </div>

            <div class="c-box" v-if="overView">继续导航  <span>{{overTime}}</span></div>

            <div class="r-box" @click="isPlay('walk')">
                <i class="iconfont icon-voice-on" v-if="playVoice"></i>
                <i class="iconfont icon-voice-off" v-else></i>
            </div>

        </div>


        <!--步行导航加载状态-->
        <div class="box navingTip loading" v-if="moduleState == 6">

            <div class="l-box" @click="back">退出</div>

            <div class="c-box">请求中...</div>

            <div class="r-box"><i class="iconfont icon-voice-off"></i></div>

        </div>

        <!--步行导航结束-->
        <div class="box navingEnd" v-if="moduleState == 7">

            <div class="login-box" v-if="loginBtn && $mapFunManger.needLogin && $mapFunManger.collectAndFoots">

                <a @click="saveFoot">
                    <i class="iconfont icon-footprint-o"></i>
                    <span v-if="!$mapStore.plugInfo.phone && $mapFunManger.needLogin">登录永久保存足迹 <span v-if="loginTime && loginTime < 6">{{loginTime}}</span></span>
                    <span v-else-if="$mapFunManger.collectAndFoots">已保存足迹,查看 <span v-if="loginTime && loginTime < 6">{{loginTime}}</span></span>
                    <i class="iconfont icon-right-01"></i>
                </a>

            </div>

            <div class="startAndEnd">
                <div class="l-box">{{walk.Start}}</div>
                <div class="r-box">{{walk.End}}</div>
            </div>

            <div class="sportsNum">

                <div class="box">

                    <i class="iconfont icon-shoes"></i>
                    <b>{{walk.Distant}}</b>
                    <span>公里</span>

                </div>

                <div class="box">
                    <i class="iconfont icon-time"></i>
                    <b>{{walk.Min}}</b>
                    <span>分钟</span>
                </div>

                <div class="box" v-if="!brtmap.existVehicle">
                    <i class="iconfont icon-fat"></i>
                    <b>{{walk.Fat}}</b>
                    <span>脂肪</span>
                </div>

                <div class="box">
                    <i class="iconfont icon-sheng"></i>
                    <b>{{walk.Omit}}</b>
                    <span>分钟</span>
                </div>
            </div>

            <div class="btn-box" @click.stop="sharePoint">邀请好友使用</div>
        </div>

        <!--步行导航结束处理-->
        <div class="box navingTip" v-if="moduleState == 8">

            <div class="l-box" @click="back('walk')">退出</div>

            <div class="c-box"><span>{{backTime||1}}</span>秒后结束导航</div>

            <div class="r-box"><i class="iconfont icon-voice-off"></i></div>

        </div>

        <!--特殊退出-->
        <div class="back" @click="back('end')" v-show="moduleState == 7"><i class="iconfont icon-left-01"></i></div>

        <!-- 导航中提示-->
        <div class="fixed-nav-tip" :state="fixedNavTip" v-if="fixedNavTip">
            <div class="wrap">
                <div class="box1">
                    <div class="load-box">
                        <div class="load">
                            <i class="iconfont icon-jiazai11"></i>
                            <i class="iconfont icon-location-2"></i>
                        </div>
                    </div>
                    <span>请稍等，正在为您切换路线...</span>
                </div>

                <div class="box2">

                    <img src="@/assets/no-route.jpg" alt="">

                    <div class="content">
                        <p class="p1">无此路线</p>
                        <p class="p2">当前位置暂无该规划路线方式<br>可选择其他方式进行规划</p>
                    </div>

                    <div class="btn-box">
                        <a @click="bus.$emit('navingToChangeRoute',2)">我知道了</a>
                    </div>
                </div>

                <div class="box3">
                    <i class="iconfont icon-selected"></i>
                    <span>已为您切换为仅{{fixedNavTxt}}路线导航</span>
                </div>

            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import Button from '../../../../../components/button/Button.vue'

    import {getPoiInfo,_init_nav} from './../../brtmap/Brtmap.js';

    import {IsPointInMatrix} from "./../../../../../utils/util"

    //import {getHistoryFootData,addHistoryFootData} from '@/config/prepare.js';

    export default {
        name: "NavingTipModule",

        data(){
            return {

                moduleState:0,

                allDistant:0,
                allTime:0,
                floorTxt:' ',

                pauseNaving:true,     //模拟导航暂停
                playVoice:true,      //导航语音暂停


                check:false,     //导航查看剩余距离及分钟数


                floorNAME:'',       //底部提示信息(导航时)
                endINFO:'',
                distant:'',
                minute:'',

                startTIME:'',
                endTIME:'',
                beginTIME:'',

                begin:false,        //开始导航

                fixedNavTip:0,      //0无 1：规划中 2：规划失败 3：规划成功
                fixedNavTxt:'',

                routeIndex:0,
                routeSelect:[
                    {
                        name:'距离最短',
                        icon:'juli',
                        ignor:[],
                    },
                    {
                        name:'直梯',
                        icon:'elevator-02',
                        ignor:['150012','150014'],
                    },
                    {
                        name:'扶梯',
                        icon:'elevator-01',
                        ignor:['150012','150013'],
                    },
                    {
                        name:'楼道',
                        icon:'elevator-03',
                        ignor:['150013','150014'],
                    }
                ],

                startTime:'',

                walk:{
                    Start:'测试',
                    End:'测试',
                    Distant:1,
                    Min:0,
                    Fat:0,
                    Omit:0
                },

                frontTIME:'',     //保持前行提示

                backTime:3,         //结束步行导航
                backClearTimer:null,   //结束

                lastFloor:'',           //上一楼层

                floorRouteIndex:0,      //楼层路由索引

                lastmapAudio:'',        //上次播放

                locationTest:false,     //定位点测试
                // currmp3Audio:'',        //当前播放

                overView:false,             //全览

                overTime:6,

                loginTime:0,                //登录

                loginBtn:false,

                $doorEndPoint:'',

                $specailEnd:false,

                $endMaker:false,

                $rssi:2,

                passed:0,

                backStatus:false
            }

        },

        created(){

            var $overViewT = '',
                $tipOne = false;

            //全览操作
            this.bus.$off('overViewNAVING');
            this.bus.$on('overViewNAVING',(res)=>{

                if(res.status == 1){

                    this.overView = true;

                    if(this.$mapStep.type == 'toNAVING'){

                        if(!$tipOne){this.$message.info('进入全览模式，暂停导航');}
                        $tipOne= true;
                        if($overViewT)clearInterval($overViewT);
                        this.overTime=6;

                        $overViewT = setInterval(()=>{

                            if(this.overTime <= 1){

                                this.bus.$emit('overViewNo');
                                clearInterval($overViewT);

                                return false;
                            }

                            this.overTime -- ;
                        },1000)


                    }


                }else{
                    this.overView = false;

                    if(this.$mapStep.type == 'toNAVING'){

                        this.$message.info('退出全览模式，继续导航');

                        if($overViewT)clearInterval($overViewT);

                        if($tipOne){//防止多次执行
                            this.bus.$emit('overViewNo');
                        }

                        this.overTime = 6;

                        $tipOne = false;

                    }

                }

            })

            //绑定事件
            this.bus.$off('naving');
            this.bus.$on('naving',(res)=>{
                if(res){

                    // if(this.$BRT.$route.selectType.type=='location'){this.$BRT.$route.selectType.pointType == 'start' ? this.$BRT.$selecte.startPoint= res : this.$BRT.$selecte.endPoint = res;}
                    // else

                    //全览不执行
                    if(this.$BRT.$NAVTO.NAVType == 'NAVINDICATE'){

                        if(!this.overView){

                            this.NAV_FUNCTION(res);
                            // this.bus.$emit('navAndLocationTest',{result:res});
                        }

                    }

                }

            })

            //监听起终点变化(监听达不到效果，主要是如果值不改变无法触发)
            this.bus.$off('startAndEnd')
            this.bus.$on('startAndEnd',(res)=>{

                /*
                * type 0规划路径 1起点 2终点
                *
                * */

                if(res.type==1){//定位为终点

                    if(!this.$BRT.$locate.point){
                        this.$BRT.$route.selectType.type ='location';
                        this.$BRT.$selecte.endPoint = '';
                    }else{
                        this.$BRT.$selecte.endPoint = JSON.parse(JSON.stringify(this.$BRT.$locate.point));
                    }


                }

                else if(res.type==2){//定位为起点

                    if(!this.$BRT.$locate.point){
                        this.$BRT.$route.selectType.type ='location';
                        this.$BRT.$selecte.startPoint='';
                    }else{
                        this.$BRT.$selecte.startPoint = JSON.parse(JSON.stringify(this.$BRT.$locate.point));
                    }
                }

                if(res.callback){

                    this.getRoutes(res.callback)

                }

                else{

                    this.getRoutes()

                }
            })
        },

        methods:{

            init(){ //初始化执行

                let $brtmap = this.$store.state.mapStore.brtmap;
                $brtmap.$route.ignore = $brtmap.$route.ignore ? $brtmap.$route.ignore : [];   //默认方式

                this.moduleState = 999; //不显示底部

                if($brtmap.$route.selectType.type){

                    let $type=$brtmap.$route.selectType.type;

                    if($type == 'map'){

                        this.moduleState = 999;//底部不显示

                    }

                }
            },

            clear(){

                this.backStatus = false;        //退出导航
                this.lastmapAudio = '';
                this.beginTIME = null;
                this.startTIME='';
                this.endTIME = '';
                this.begin = false;
                this.startTime = '';

                this.backClearTimer = null;
                //登录
                this.loginTime = 0;


                //重新规划路径
                this.bus.$emit('startAndEnd',{type:0});

                //区域触发清空
                this.bus.$emit('navArea',{status:1});



                //关闭导航视角
                this.bus.$emit('locationView',false);

                this.$BRT.$NAVTO.NAVType='';
                this.$mapStep.type ='planRoute';

                this.moduleState = 0;

                //移除图标
               setTimeout(()=>{
                   this.$BRT.$marker.navLocation.empty();
                   this.$BRT.$marker.tipPopup.empty();
               },10)

            },

            back(type){


                // $VAR.map.setMaxBounds($VAR.map.currentMapInfo.getBounds(0.2));

                if(type == 'end'){

                    this.clear();

                }else{

                    this.backStatus = true;
                    $VAR.$nav.exit();

                }

            },

            isPlay(type){

                if(type == 'analog'){

                    // this.pauseNaving == true ? (this.pauseNaving =false,this.$BRT.$NAVTO.$NAVSIMULATE.stop()):(this.pauseNaving =true,this.$BRT.$NAVTO.$NAVSIMULATE.start())

                    if($VAR.$nav.pointCount<5){
                        this.$message.info('正在准备请稍等~~');
                        return;
                    }

                    if(this.pauseNaving == true){

                        this.pauseNaving =false;
                        if($VAR.$nav && $VAR.$nav.pause)$VAR.$nav.pause();

                    }else{
                        this.pauseNaving =true;
                        $VAR.$nav.resume();
                    }


                }
                else{
                    this.playVoice = this.playVoice == true ? false : true;
                    $VAR.$nav.voice = this.playVoice;
                }

            },

            saveFoot(){

                let callback = ()=>{
                    this.$message.load(true);

                    //前往搜索页并展开历史足迹
                    setTimeout(()=>{

                        this.$message.load(false);
                        this.$mapStep.type = '';
                        this.$mapStep.POI_ID = '';
                        this.$BRT.$options.Footprint = true;

                        //还原默认车行方式
                        this.$BRT.$CAR_FIRST = this.$BRT.$CAR_BASE_FIRST;

                        this.$router.replace('/search');

                        this.$BRT.$selecte.startPoint = null;
                        this.$BRT.$selecte.endPoint = null;

                        this.back('end');
                        this.$mapStep.type = '';

                    },500)
                }

                if(this.$mapFunManger.collectAndFoots === 2){
                    if(!this.$mapStore.plugInfo.phone){

                        //登录并保存历史足迹
                        this.bus.$emit('LoginCallback',{status:1,save:1});

                        //结束定时器(不隐藏按钮)
                        this.loginTime = 100;
                    }
                    else{
                        callback && callback()
                    }
                }
                else if(this.$mapFunManger.collectAndFoots === 1){
                    callback && callback()
                }

            },

            //途经点marker关闭图标控制
            keyPointMarker(n){

                let keyPoints = this.brtmap.$route.keyPoints,
                    _callback = (n)=>{
                        keyPoints.map(item=>{
                            if(item.marker){
                                if(n === 1){
                                    item.marker.addClass('close-off')
                                }else if(n===2){
                                    item.marker.removeClass('close-off')
                                }else{
                                    item.marker.empty();
                                }

                            }
                        })
                    };
                _callback(n);

            },


            //获取规划路径
            getRoutes(callback){

                let $this =this,
                    $endPoint={},
                    $startPoint ={},
                    $brtmap = $this.$store.state.mapStore.brtmap;

                //先隐藏室外路线
                this.$mapStep.openQQMapRoute = false;

                $brtmap.openVehicle = false;

                //防止干扰
                $brtmap.$marker.navLocation.empty();

                //初始链接规划清理
                if($this.$BRT.$urlParam.planRoute.status){
                    $this.$message.load(false);
                    $this.$BRT.$urlParam.planRoute.status = false;
                    $this.$BRT.$urlParam.planRoute.startPoi = '';
                    $this.$BRT.$urlParam.planRoute.endPoi = '';
                }

                if(!$brtmap.$selecte.startPoint && !$brtmap.$selecte.endPoint){//清空

                    $VAR.map.resetRoute();
                    this.$BRT.$marker.start.empty();
                    this.$BRT.$marker.end.empty();
                    this.$BRT.$route.selectType.type = '';

                    //关闭选择方式
                    this.bus.$emit('routeTypeHide',{status:1})
                    return
                }

                //起点与插标处理
                if($brtmap.$selecte.startPoint){

                    //起点为定位点
                    if($brtmap.$selecte.startPoint.x && $brtmap.$selecte.startPoint.y){

                        //保存路径规划所需数据
                        $startPoint= $brtmap.$selecte.startPoint;

                        let lngLat =  $VAR.map.coordsToLnglat($brtmap.$selecte.startPoint.x,$brtmap.$selecte.startPoint.y);

                        //防止楼层不一致拿错数据(只能获取显示楼层的poi信息)
                        let  $poi = getPoiInfo($brtmap,$VAR.map.project(lngLat));

                        if($poi && $poi.floor == $startPoint.floor){
                            $brtmap.$selecte.startPoint = $poi;
                        }


                        $brtmap.$selecte.startPoint.LABEL_X = $startPoint.x;
                        $brtmap.$selecte.startPoint.LABEL_Y = $startPoint.y;

                        //存在为定位点
                        if($startPoint.lng && $startPoint.lat){
                            $brtmap.$selecte.startPoint.NAME = '我的位置';
                        }

                        // if(['逃生通道','无名地址'].indexOf($brtmap.$selecte.startPoint.NAME) === -1){
                        //     $brtmap.$selecte.startPoint.NAME = '我的位置';
                        // }

                        //防止没有楼层信息
                        let $floor = $VAR.map.getFloorInfoByIndex($startPoint.floor);

                        $floor = Object.assign($floor,{
                            FLOOR_NUMBER:$floor.floorNumber,
                            FLOOR_NAME:$floor.floorName,
                            FLOOR_ID:$floor.floorID
                        })

                        $brtmap.$selecte.startPoint = Object.assign({},$brtmap.$selecte.startPoint,$floor)

                    }

                    else{

                        $startPoint.x = $brtmap.$selecte.startPoint.LABEL_X;
                        $startPoint.y = $brtmap.$selecte.startPoint.LABEL_Y;
                        $startPoint.floor = $brtmap.$selecte.startPoint.floor ? $brtmap.$selecte.startPoint.floor : $brtmap.$selecte.startPoint.FLOOR_NUMBER

                    }

                    $VAR.map.currentMapInfo.floorNumber == $startPoint.floor ? $brtmap.$marker.start.setLnglat($VAR.map.coordsToLnglat($startPoint.x,$startPoint.y)) : $brtmap.$marker.start.empty();//起点标


                    //移除提示
                    $brtmap.$marker.start.removeClass('showTip');

                }

                else{

                    if($brtmap.$NAVTO.NAVType != 'NAVINDICATE'){    //导航偏航不需要处理
                        //防止临时切换
                        setTimeout(()=>{

                            this.$BRT.$marker.start.empty();

                            if(!(!!$brtmap.$selecte.startPoint)){

                                //&& this.$BRT.$route.selectType.type !='location'
                                if(this.$BRT.$route.selectType.type !='map'){this.moduleState = 2}



                                $VAR.map.resetRoute();
                                this.$BRT.$marker.start.empty();

                                //关闭选择方式
                                this.bus.$emit('routeTypeHide',{status:1});

                                if($brtmap.$selecte.endPoint){

                                    $VAR.map.easeTo({
                                        center:$VAR.map.coordsToLnglat($endPoint.x,$endPoint.y)
                                    })

                                    if($VAR.map.currentMapInfo.floorNumber != $endPoint.floor){  //切换楼层

                                        let $zoom = $VAR.map.getZoom(),
                                            $floorId = $VAR.map.getFloorInfoByIndex($endPoint.floor).floorID;

                                        $VAR.map.setFloor($floorId,()=>{
                                            $VAR.map.stop().easeTo({
                                                zoom:$zoom
                                            })
                                        });

                                        $brtmap.$marker.end.setLnglat($VAR.map.coordsToLnglat($endPoint.x,$endPoint.y))
                                    }

                                }

                            }
                        },300)
                    }


                }

                //终点与插标处理
                if($brtmap.$selecte.endPoint){

                    //终点为定位点
                    if($brtmap.$selecte.endPoint.x && $brtmap.$selecte.endPoint.y){

                        $endPoint = $brtmap.$selecte.endPoint;  //保存路径规划所需数据

                        let lngLat =  $VAR.map.coordsToLnglat($brtmap.$selecte.endPoint.x,$brtmap.$selecte.endPoint.y);

                        //防止楼层不一致拿错信息
                        let  $poi = getPoiInfo($brtmap,$VAR.map.project(lngLat));
                        if($poi && $poi.floor == $endPoint.floor){
                            $brtmap.$selecte.endPoint = getPoiInfo($brtmap,$VAR.map.project(lngLat))
                        }

                        $brtmap.$selecte.endPoint.LABEL_X = $endPoint.x;
                        $brtmap.$selecte.endPoint.LABEL_Y = $endPoint.y;

                        if($endPoint.lng && $endPoint.lat){
                            $brtmap.$selecte.endPoint.NAME = '我的位置';
                        }

                        //防止没有楼层信息
                        let $floor = $VAR.map.getFloorInfoByIndex($endPoint.floor);

                        $floor = Object.assign($floor,{
                            FLOOR_NUMBER:$floor.floorNumber,
                            FLOOR_NAME:$floor.floorName,
                            FLOOR_ID:$floor.floorID
                        })

                        $brtmap.$selecte.endPoint = Object.assign({},$brtmap.$selecte.endPoint,$floor)

                    }

                    else{

                        $endPoint.x = $brtmap.$selecte.endPoint.LABEL_X;
                        $endPoint.y = $brtmap.$selecte.endPoint.LABEL_Y;
                        $endPoint.floor = $brtmap.$selecte.endPoint.floor ? $brtmap.$selecte.endPoint.floor : $brtmap.$selecte.endPoint.FLOOR_NUMBER;

                    }

                    if($VAR.map.currentMapInfo.floorNumber == $endPoint.floor){
                        $brtmap.$marker.end.setLnglat($VAR.map.coordsToLnglat($endPoint.x,$endPoint.y))

                    }else {

                        $brtmap.$marker.end.empty();

                    }


                    $brtmap.$marker.end.removeClass('showTip');

                }

                else{

                    setTimeout(()=>{

                        this.$BRT.$marker.end.empty();

                        if(!(!!$brtmap.$selecte.endPoint)){

                            //&& this.$BRT.$route.selectType.type !='location'
                            if(this.$BRT.$route.selectType.type !='map'){this.moduleState = 3}


                            $VAR.map.resetRoute();
                            this.$BRT.$marker.end.empty();
                            //关闭选择方式
                            this.bus.$emit('routeTypeHide',{status:1});

                            if($brtmap.$selecte.startPoint){

                                $VAR.map.easeTo({
                                    center:$VAR.map.coordsToLnglat($startPoint.x,$startPoint.y)
                                })

                                if($VAR.map.currentMapInfo.floorNumber != $startPoint.floor){  //切换楼层


                                    let $zoom = $VAR.map.getZoom(),
                                        $floorId = $VAR.map.getFloorInfoByIndex($startPoint.floor).floorID;

                                    $VAR.map.setFloor($floorId,()=>{
                                        $VAR.map.stop().easeTo({
                                            zoom:$zoom
                                        })
                                    });

                                    $brtmap.$marker.start.setLnglat($VAR.map.coordsToLnglat($startPoint.x,$startPoint.y))
                                }
                            }
                        }

                    },300)

                }

                $brtmap.$marker.selected.empty();   //清空选点标点

                // alert('$brtmap.$selecte.start'+JSON.stringify($brtmap.$selecte.startPoint))
                // alert('$brtmap.$selecte.endPoint'+JSON.stringify($brtmap.$selecte.endPoint))
                // alert('$startPoint:'+JSON.stringify($startPoint));
                // alert('$endPoint:'+JSON.stringify($endPoint));
                // console.log('$brtmap.$selecte.endPoint',$brtmap.$selecte.endPoint,'$brtmap.$selecte.startPoint',$brtmap.$selecte.startPoint);
                // console.log('$startPoint',$startPoint,'$endPoint',$endPoint);

                //规划路径(存在值)
                if($startPoint.x && $endPoint.x){

                    $brtmap.$route.selectType ={type:null,pointType:null,point:null}   //清空选点方式影响

                    if($brtmap.$selecte.endPoint && $brtmap.$selecte.endPoint.POI_ID){
                        $VAR.map.setReportEndPOI($brtmap.$selecte.endPoint);
                    }


                    /***采用车行或是人行规划**/

                    //判断起终点是否是停车楼层
                    let plugInSettings = $this.$mapStore.plugInfo.plugInfo.plugInSettings,
                        carParkFloor = [];

                    //默认关闭车行
                    $brtmap.openVehicle = false;
                    $brtmap.$route.vehicle = false;
                    this.bus.$emit('routeVehicleHide',0);

                    if(plugInSettings && JSON.parse(plugInSettings.map).floorType){

                        carParkFloor = JSON.parse(plugInSettings.map).floorType.stopcar;

                        let start = $brtmap.$selecte.startPoint,
                            end = $brtmap.$selecte.endPoint;

                        if( carParkFloor.indexOf(start.FLOOR_ID) > -1 &&
                            carParkFloor.indexOf(end.FLOOR_ID) > -1){

                            $brtmap.openVehicle =  true;


                            //开启车行||人行选项
                            if(!$brtmap.$route.vehicleRoute && $brtmap.$CAR_FIRST){
                                //默认取车行
                                this.bus.$emit('routeVehicleHide',1);

                                if(!$brtmap.$route.vehicle){
                                    $brtmap.$route.vehicle = true;
                                }

                                if($brtmap.$route.ignore && JSON.stringify($brtmap.$route.ignore) !='[]'){
                                    $brtmap.$route.ignore = [];
                                    return;
                                }

                            }else{

                                this.bus.$emit('routeVehicleHide',0);

                            }

                        }

                    }


                    /******是否存在途径点*******/

                    let keyPoints = [];
                    if($brtmap.$route.keyPoints.length){
                        $brtmap.$route.keyPoints.map(item=>{

                            if(item.marker){
                                item.marker.empty();
                            }

                            let keypoint = $VAR.map.coordsToLnglat(item.point.LABEL_X,item.point.LABEL_Y);
                            keypoint.floor = item.point.FLOOR_NUMBER;

                            keyPoints.push(keypoint)
                        })
                    }

                    /******是否存在途径点*******/




                    /****规划参数****/
                    let param = {
                        ignore : $brtmap.$route.ignore,
                        vehicle: $brtmap.$route.vehicle,
                        sameFloorFirst:true,    //同层优先
                        ignoreFirstMeters:100     //规划忽略小拐脚
                    };


                    if($brtmap.$route && $brtmap.$route.isExit){
                        param = {
                            isExit:true,
                            ignore:['150013'],
                            sameFloorFirst:true,    //同层优先
                            vehicle: $brtmap.$route.vehicle
                        }
                    }
                    /****规划参数****/

                    $VAR.map.requestRoute($startPoint,$endPoint,keyPoints,
                        res=>{

                        //设置路线分析
                        $VAR.$nav.routeAnalyze(res);

                        //记录终点坐标
                        $brtmap.$selecte.navEndPoint = $endPoint;

                        //开启室外路线入口
                        if(!this.$BRT.$locate.point){
                            this.$mapStep.openQQMapRoute = true;
                        }

                        //统计终点POI信息
                        $VAR.map.setReportEndPOI($brtmap.$selecte.endPoint);

                        //设置路线规划信息 (起点信息 {x:x,y:y,f:floorNumber,pi:POIID},终点信息 {x:x,y:y,f:floorNumber,pi:POIID}，类型[1：人；2：车], 业务类型[1：电梯；2：扶梯；3：楼梯；4：其他] )
                        let upstart = {x:$startPoint.x,y:$startPoint.y,f:$startPoint.floor,pi:$brtmap.$selecte.startPoint.POI_ID},
                            upend = {x:$endPoint.x,y:$endPoint.y,f:$endPoint.floor,pi:$brtmap.$selecte.endPoint.POI_ID},
                            vehicle = $brtmap.$route.vehicle ? 2 : 1,
                            type = 4;

                        let typeStr = '';
                        $brtmap.$route.ignore.map(item=>{ typeStr +=item;})

                        if(typeStr.indexOf('150012') == -1){
                            type = 2;
                        }else if(typeStr.indexOf('150013') == -1){
                            type = 1;
                        }else if(typeStr.indexOf('150014') == -1){
                            type = 3;
                        }

                        this.$userUpdata.setRouteCalculate(upstart,upend,vehicle,type);

                       //设置路线规划信息 (起点信息 {x:x,y:y,f:floorNumber,pi:POIID},终点信息 {x:x,y:y,f:floorNumber,pi:POIID}，类型[1：人；2：车], 业务类型[1：电梯；2：扶梯；3：楼梯；4：其他] )

                        window.closeKeyPoint = function($that){

                            let index = $that.getAttribute('data-index');
                            $this.bus.$emit('keyPointDelete',index);

                        }

                        //途径点插标
                        if($brtmap.$route.keyPoints.length){

                                $brtmap.$route.keyPoints.map((item,index)=>{

                                    let keypoint = $VAR.map.coordsToLnglat(item.point.LABEL_X,item.point.LABEL_Y);
                                    keypoint.floor = item.point.FLOOR_NUMBER;

                                    let html = `<div class="wrap"><div class="border"></div><div class="bg"></div><i><font>${index + 1}</font></i></div><i class="iconfont icon-cha"" data-index="${index}" onclick="closeKeyPoint(this)"></i>`;

                                    item.marker = new brtmap.Symbol.DivMarker({
                                        content:html,
                                        className:'point-marker keyPoint',
                                    }).addTo($VAR.map);

                                    item.marker.setLnglat(keypoint);
                                })

                            }

                        this.bus.$emit('locateFailClose');
                        // //缩小地图并设置为起点楼层
                        if(this.$mapStep.type != 'toNAVING'){   //防止影响导航地图调整

                            this.moduleState= 0;
                            if($VAR.map.currentMapInfo.floorNumber != $startPoint.floor){
                                let $zoom = $VAR.map.getZoom(),
                                    $floorId = $VAR.map.getFloorInfoByIndex($startPoint.floor).floorID;

                                $VAR.map.setFloor($floorId,()=>{
                                    $VAR.map.stop().easeTo({
                                        zoom:$zoom
                                    })
                                });
                            }

                            //设置为基础级别，并设置起点为中心
                            $VAR.map.easeTo({
                                zoom:$VAR.map.getBaseZoom(),
                                center:$VAR.map.coordsToLnglat($startPoint.x,$startPoint.y),
                                bearing:$brtmap.$NAVTO.initAngle
                            })

                            //设置第一个点为插标起点
                            $brtmap.$marker.start.setLnglat(res.start);


                            if($VAR.map.currentMapInfo.floorNumber == $endPoint.floor){  //切换后在一个楼层
                                $brtmap.$marker.end.empty();
                                $brtmap.$marker.end.setLnglat($VAR.map.coordsToLnglat($endPoint.x,$endPoint.y));
                            }

                        }

                        else{

                            //防止偏转
                            $this.startTIME= null;
                            $this.endTIME = null;

                            //清空已设置
                            $this.floorRouteIndex = 0;
                            callback && callback(res);

                        }

                        //设置路由颜色
                        let RouteColor = this.$mapStore.plugInfo.plugInfo.plugInSettings.lineColor ? this.$mapStore.plugInfo.plugInfo.plugInSettings.lineColor : '#0099FF';
                        $VAR.map.setRouteColor(RouteColor, "rgba(255,255,255,0.6)");

                        var _CountDistance = 0, _routeResult = res.result.route[0].route; //res.result.route[0].route

                        // console.log('规划路线',res);
                        // console.log('规划数组',res.result.route);

                        //多途径点拼接多个
                        // res.result.route.map(item=>{
                        //     if(item.route && item.route.length){
                        //
                        //         if(_routeResult.length){
                        //             _routeResult = _routeResult.concat(item.route)
                        //         }else{
                        //             _routeResult = item.route;
                        //         }
                        //     }
                        // })
                        // console.log(' _routeResult', _routeResult);


                        for(var i = 0; i < _routeResult.length; i++){

                            var _route = _routeResult[i].coordinates;

                            for(var k = 0, len = _route.length; k < len - 1; k++){

                                var _point1 = $VAR.map.lnglatToCoords(_route[k][0], _route[k][1]),
                                    _point2 = $VAR.map.lnglatToCoords(_route[k+1][0], _route[k+1][1]);

                                var _d = Math.sqrt((_point1.x - _point2.x) * (_point1.x - _point2.x) + (_point1.y - _point2.y) * (_point1.y - _point2.y));

                                _CountDistance += _d;
                            }

                        }

                        //参数设置
                        this.allDistant = Math.ceil(_CountDistance);
                        this.allTime = Math.ceil(_CountDistance / 1.2 / 60);

                        // $VAR.map.currentMapInfo.floorNumber

                        if(_routeResult.length>0){

                            if($startPoint.floor == $endPoint.floor){
                                //关闭选择方式
                                this.bus.$emit('routeTypeHide',{status:1});
                            }

                            if($startPoint.floor == $endPoint.floor){

                                if(_routeResult.length == 1){
                                    this.floorTxt = '无需跨楼层到达';
                                }else{
                                    this.floorTxt = '同层需跨层到达';
                                }

                            }else{

                                if($startPoint.floor > $endPoint.floor){
                                    this.floorTxt = '需下行至'+$VAR.map.getFloorInfoByIndex($endPoint.floor).floorName+'层';
                                }else{
                                    this.floorTxt = '需上行至'+$VAR.map.getFloorInfoByIndex($endPoint.floor).floorName+'层';
                                }

                            }
                        }

                        else{
                            this.floorTxt = null
                        }

                        //保存路由
                        $brtmap.$route.route =_routeResult;

                        // console.log(res.result.route[0], Math.round(_CountDistance));


                    },
                        err=>{

                        if(this.$mapStep.type !='toNAVING'){    //导航不清空

                            //开启车行||人行选项
                            if($brtmap.$route.vehicle && $brtmap.$mapStep.type !='toNAVING'){
                                this.bus.$emit('routeVehicleHide',1);
                            }


                            //移除起终点及插标
                            $brtmap.$marker.start.empty();
                            $brtmap.$marker.end.empty();
                            $VAR.map.resetRoute();
                            $brtmap.$route.route=null;
                            this.moduleState= 1;

                        }

                        else{
                            callback && callback(false);
                            // this.$message.info('导航偏转规划失败');
                        }

                    },
                        param
                    )

                }
            },

            //导航准备
            goToNav(type){  //导航准备

                if(type == 'ar'){

                    if(this.$systemEnviron != 2){this.$message.info('仅支持小程序打开');return;}

                    if(!localStorage.getItem('ArTips_jianfa')){
                        this.$router.push(`/arTip?poiId=${this.$BRT.$selecte.endPoint.POI_ID}`);
                    }else{
                        let $url = `/pages/live/live?poiId=${this.$BRT.$selecte.endPoint.POI_ID}&language=zh`;
                        // if(this.carReport){$url +=`&searchId=${this.carReport.getSearchId()}`}
                        this.wx.miniProgram.navigateTo({url:$url});
                    }

                    return;
                }

                if(type!='analog' && !this.$BRT.$locate.point){
                    this.$message.info('定位成功才能开启哟~~');
                    return;
                }


                let $this = this,point = null;

                this.$mapStep.type = 'toNAVING';

                this.lastFloor = '';
                $this.floorRouteIndex = 0;
                $this.backTime=3;
                $this.backClearTimer = null;
                $this.$endMaker = false;
                // $VAR.map.setMaxBounds($VAR.map.currentMapInfo.getBounds(0.2));

                let $pluset = $this.$mapStore.plugInfo.plugInfo.plugInSettings;
                let $plugNav = JSON.parse($pluset.navigation);

                this.moduleState = 6;//路径加载状态

                this.playVoice = this.$BRT.$options.voice;//初始化语音
                $VAR.$nav.voice = this.playVoice;

                //初始化进度条
                this.bus.$emit('navtopSet',{status:3});

                //全览限制
                this.overView = false;

                //防止干扰模拟导航
                $this.$specailEnd = false;
                $this.$doorEndPoint = '';

                $VAR.$nav.followBearing = true;

                this.playVoice = this.$BRT.$options.voice;//初始化语音

                //组装数据
                let _params_ = {
                    voice:this.playVoice,
                    indicateDistance:$plugNav.nowdistant - 0 || 15,
                    inertanceSpeed:$plugNav.nowspeed - 0 || 1.2,
                    earlyDistance:$plugNav.endDistance - 0 || 6,
                    yawDistance:$plugNav.pathDeviation - 0 || 10,
                    yawDelayTime:1000,
                    advanceDistance:2,
                    openInertance:true,

                    simulate:{
                        voice:this.playVoice,
                        earlyDistance:3,
                        advanceDistance:0,
                        openInertance:true,
                        indicateDistance:$plugNav.nowdistant - 0 || 15,
                        inertanceSpeed:$plugNav.simspeed - 0 || 2
                    }
                },
                getRemainParam = (obj,attr)=>{
                        let _obj_ = {};
                        for (let k in obj){
                            if(k != attr)_obj_[k] = obj[k]
                        }
                        return _obj_;
                    };

                //特殊处理步行需保留之前的方式(设置选用设置的，未设置选用之前的)
                if(typeof  _navigation_params_ != "undefined"){
                    let __params__ = _navigation_params_;
                    if(this.$BRT.$route.vehicle){
                        //车行
                        Object.assign(_params_,__params__['vehicle']);

                    }
                    else{

                        //人行
                        let _merge_ = (obj,obj1)=>{

                            let _obj_ = {...obj1};
                            for(let k in obj){
                                if(typeof obj[k] === "object" && typeof obj1[k] === "object"){
                                    _obj_[k] = _merge_(obj[k],obj1[k])
                                }
                                else{
                                    if(obj[k])_obj_[k] = obj[k];
                                }
                            }

                            return _obj_;
                        };

                        _params_ = _merge_(__params__['walk'],_params_);
                    }
                }


                if(type == 'analog'){

                    this.keyPointMarker(1);

                    //模拟导航
                    $this.$BRT.$NAVTO.NAVType = 'NAVSIMULATE';

                    $this.frontTIME = new Date().getTime();

                    $this.pauseNaving = true;

                    $VAR.$nav.endPoiId = '';

                    Object.assign($VAR.$nav,_params_.simulate);

                    //开启导航视角
                    $this.bus.$emit('locationView','init');
                    $VAR.$nav.simulate();
                }

                else{

                    //登录
                    this.loginTime = 0;

                    //步行导航
                    $this.$BRT.$NAVTO.NAVType = 'NAVINDICATE';

                    this.keyPointMarker(2);


                    //设置属性值
                    Object.assign($VAR.$nav,getRemainParam(_params_,'simulate'));


                    //设置终点(设置以门节点为结束点 不设置不以门节点结束)
                    $VAR.$nav.endPoiId = this.$BRT.$selecte.endPoint.POI_ID;

                    //起点初始化
                    let lnglat = '';
                    if($this.$BRT.$selecte.startPoint.LABEL_X){
                        lnglat = $VAR.map.coordsToLnglat($this.$BRT.$selecte.startPoint.LABEL_X,$this.$BRT.$selecte.startPoint.LABEL_Y);
                    }

                    else{

                        lnglat = $VAR.map.coordsToLnglat($this.$BRT.$selecte.startPoint.x,$this.$BRT.$selecte.startPoint.y);
                    }

                    point = {
                        x:$this.$BRT.$selecte.startPoint.LABEL_X ? $this.$BRT.$selecte.startPoint.LABEL_X : $this.$BRT.$selecte.startPoint.x,
                        y:$this.$BRT.$selecte.startPoint.LABEL_Y ? $this.$BRT.$selecte.startPoint.LABEL_Y : $this.$BRT.$selecte.startPoint.y,
                        floor:$this.$BRT.$selecte.startPoint.floor ? $this.$BRT.$selecte.startPoint.floor  : $this.$BRT.$selecte.startPoint.FLOOR_NUMBER ,
                        lng:lnglat.lng,
                        lat:lnglat.lat,
                        rssi:0,
                        angle:0
                    }

                    $this.NAV_FUNCTION(point);

                    //开启导航视角
                    $this.bus.$emit('locationView','init');
                    $VAR.$nav.startNavi(this.$BRT.$route.vehicle?2:1);
                }

            },


            NAV_FUNCTION(point){    //导航中状态处理

                let $this = this,

                    $brtmap = this.$store.state.mapStore.brtmap;

                $this.$rssi = point.rssi;

                $VAR.$nav.locateAnalyze(point);
            },

            sharePoint(){
                this.bus.$emit('shareCallback',{status:1,shareInfo:''})
            },

            changeRoute(index,item){
                this.routeIndex = index;
                this.$store.state.mapStore.brtmap.$route.ignore = item.ignor;
            },
        },


        watch:{



            ignore(v1,v2){  //改变路径方式

                //统一跨层标识
                this.routeSelect.map((item,index)=>{

                    let i1 = '';
                    item.ignor.map(child=>{
                        i1 +=child;
                    })

                    let i2 = '';
                    v1.map(child=>{
                        i2 +=child;
                    })

                    if(i1 == i2){
                        this.fixedNavTxt = item.name;
                        this.routeIndex = index;
                    }
                })


                //防止导航中触发规划
                if(this.$mapStep.type !='toNAVING')this.getRoutes();

            },

            mapstep(v1,v2){
                //初始化
                if(v1 =='planRoute' && v2 !='toNAVING'){this.init();}
            },


        },

        computed:{

            ...mapState({
                brtmap:state=>state.mapStore.brtmap
            }),

            ignore(){
                return this.$store.state.mapStore.brtmap.$route.ignore;
            },

            mapstep(){
                return this.$mapStep.type;
            },

        },


        components:{
            Button
        },


        mounted(){

            //实例化导航
            _init_nav.call(this);

            //地图未加载
            if(this.$BRT.$urlParam.NomapReady == 2){
                setTimeout(()=>{
                    this.bus.$emit('startAndEnd', {type: 0});
                },0)
            }

            //链接初始规划路径

            if(this.$BRT.$urlParam.planRoute.status){

                let locate,
                    planRoute = this.$BRT.$urlParam.planRoute,
                    $start = planRoute.startPoi,
                    $end = planRoute.endPoi,

                    $fail = ()=>{
                        this.$message.load(false);
                        this.$BRT.$urlParam.planRoute.status = false;
                        this.$BRT.$urlParam.planRoute.startPoi = '';
                        this.$BRT.$urlParam.planRoute.endPoi = '';
                        this.$message.info('数据获取失败');
                    },

                    _callback = (poiID,callback)=>{

                        let callee = ()=>{
                            $VAR.brtmapSearch.query({
                                    type:'poiid',
                                    value:poiID
                                },
                                function (result) {


                                    result = result.filter((item,index,self)=>{
                                        return item.POI_ID == poiID
                                    })


                                    if(result[0]){

                                        callback && callback(result[0])

                                    }else{
                                        $fail && $fail();
                                    }

                                });
                        }

                        if(!this.$mapEventManger.mapQueryStatus){

                            this.$mapEventManger.mapQueryEvents.push(()=>{
                                callee && callee();
                            })

                        }

                        else{
                            callee && callee();
                        }
                    },

                    callee = ()=>{
                        if($start && $end){


                            if([$start,$end].indexOf('locate') === -1){

                                _callback($start,(res)=>{
                                    $start = res;

                                    _callback($end,($res)=>{

                                        $end = $res;
                                        this.$BRT.$selecte.endPoint = $end;
                                        this.$BRT.$selecte.startPoint = $start;
                                        this.$mapStep.type ='planRoute';
                                        this.bus.$emit('startAndEnd',{type:0});

                                    })
                                });

                            }else{

                                if($start == 'locate'){

                                    _callback($end,$res=>{

                                        $end = $res;

                                        this.$BRT.$selecte.endPoint = $end;
                                        this.$BRT.$selecte.startPoint = locate;
                                        this.$mapStep.type ='planRoute';
                                        this.bus.$emit('startAndEnd',{type:0});
                                    })

                                }else{

                                    _callback($start,$res=>{

                                        $start = $res;
                                        this.$BRT.$selecte.endPoint = locate;
                                        this.$BRT.$selecte.startPoint = $start;

                                        this.$mapStep.type ='planRoute';
                                        this.bus.$emit('startAndEnd',{type:0});
                                    })

                                }

                            }

                        }

                        else if($start){

                            if($start == 'locate'){

                                this.$BRT.$selecte.startPoint = locate;
                                this.$BRT.$selecte.endPoint = null;
                                this.bus.$emit('startAndEnd',{type:0});
                                this.$mapStep.type ='planRoute';


                            }else{
                                _callback($start,(res)=>{
                                    this.$BRT.$selecte.startPoint = res;
                                    this.$BRT.$selecte.endPoint = null;
                                    this.bus.$emit('startAndEnd',{type:0});
                                    this.$mapStep.type ='planRoute';
                                })
                            }

                        }

                        else{


                            //起点需要定位
                            this.bus.$off('getPlanRoute_start');
                            this.bus.$on('getPlanRoute_start',(res)=>{

                                if(!res.status){    //获取定位点

                                    if($end == 'locate'){

                                        this.$BRT.$selecte.startPoint = res;
                                        this.$BRT.$selecte.endPoint = locate;
                                        this.bus.$emit('startAndEnd',{type:0});
                                        this.$mapStep.type ='planRoute';

                                    }else{

                                        _callback($end,($res)=>{
                                            this.$BRT.$selecte.startPoint = res;
                                            this.$BRT.$selecte.endPoint = $res;
                                            this.bus.$emit('startAndEnd',{type:0});
                                            this.$mapStep.type ='planRoute';
                                        })

                                    }



                                }else{

                                    if($end == 'locate'){

                                        this.$BRT.$selecte.startPoint = null;
                                        this.$BRT.$selecte.endPoint = locate;
                                        this.bus.$emit('startAndEnd',{type:0});
                                        this.$mapStep.type ='planRoute';


                                    }else{

                                        _callback($end,($res)=>{
                                            this.$BRT.$selecte.startPoint = null;
                                            this.$BRT.$selecte.endPoint = $res;
                                            this.bus.$emit('startAndEnd',{type:0});
                                            this.$mapStep.type ='planRoute';
                                        })
                                    }


                                    // $fail && $fail();
                                }
                            })

                        }
                    };


                if([$start,$end].indexOf('locate') > -1){

                    locate = {
                        x:planRoute.x,
                        y:planRoute.y,
                        floor:planRoute.floor,
                        NAME:planRoute.name
                    };

                    //计算位置(定时器:防止地图没准备好)
                    setTimeout(()=>{

                        let lngLat =  $VAR.map.coordsToLnglat(locate.x,locate.y),
                            $poi = getPoiInfo(this.$BRT,$VAR.map.project(lngLat),10);

                        if($poi && $poi.floor === locate.floor){

                            $poi.LABEL_X = locate.x;
                            $poi.LABEL_Y = locate.y;
                            $poi.NAME = $poi.NAME || locate.NAME;

                            //防止没有楼层信息
                            let $floor = $VAR.map.getFloorInfoByIndex($poi.floor);

                            $floor = Object.assign($floor,{
                                FLOOR_NUMBER:$floor.floorNumber,
                                FLOOR_NAME:$floor.floorName,
                                FLOOR_ID:$floor.floorID
                            })

                            locate = Object.assign($poi,$floor)
                        }

                        callee();

                    },1000)
                }

                else{
                    callee();
                }


            }
        },


    }
</script>

<style lang="less">
    @import "NavingTipModule.less";
</style>
